import {onFind} from "@elements/init-modules-in-scope";
import {findIn, on, closest, setAttribute, removeAttribute, addClass} from "@elements/dom-utils";
import * as numberSpinner from '../libs/number-spinner';
import Tooltip from "bootstrap/js/dist/tooltip";

export function init() {
    onFind('.js-product-number-spinner', function (element) {
        numberSpinner.createNumberSpinner(element, {}, {
            base: '.js-product-number-spinner',
            input: '.js-product-number-spinner__input',
            upButton: '.js-product-number-spinner__up',
            downButton: '.js-product-number-spinner__down'
        });

        let tooltipInstance;

        let inputElement = findIn('.js-product-number-spinner__input', element);
        on('change', () => {
            if (inputElement.getAttribute('step') && parseFloat(inputElement.getAttribute('step')) !== 0) {
                let steps = inputElement.getAttribute('step');
                inputElement.value = Math.ceil(inputElement.value / steps) * steps;
            } else {
                inputElement.value = Math.trunc(inputElement.value);
            }

            if (tooltipInstance) {
                tooltipInstance.hide();
            }
        }, inputElement)


        tooltipInstance = Tooltip.getOrCreateInstance(inputElement, {
            title: inputElement.getAttribute('data-validation-greater-than___message') ? inputElement.getAttribute('data-validation-greater-than___message') : '',
            trigger: 'manual'
        });

        on('keyup', (evt) => {
            if (parseFloat(inputElement.value) < parseInt(inputElement.getAttribute('min'))) {
                tooltipInstance._config.title = inputElement.getAttribute('data-validation-greater-than___message');
                tooltipInstance.show();
            } else {
                if (tooltipInstance && !(parseFloat(inputElement.value) > parseInt(inputElement.getAttribute('max')))) {
                    tooltipInstance.hide();
                }
            }

            if (parseFloat(inputElement.value) > parseInt(inputElement.getAttribute('max'))) {
                tooltipInstance._config.title = inputElement.getAttribute('data-validation-less-than___message');
                tooltipInstance.show();
            } else {
                if (tooltipInstance && !(inputElement.value < inputElement.getAttribute('min'))) {
                    tooltipInstance.hide();
                }
            }
        }, inputElement)

        if (inputElement.getAttribute('data-max-cart') === 'true') {
            if (inputElement.getAttribute('max') < 1) {
                inputElement.value = 0;
            }

            on('cart.success', () => {
                setAttribute('max', inputElement.getAttribute('max') - inputElement.value, inputElement)

                if (inputElement.value > inputElement.getAttribute('max')) {
                    inputElement.value = 1;
                    setAttribute('disabled', true, findIn('.js-product-number-spinner__down', closest('form', inputElement)));

                    if (inputElement.getAttribute('max') === '1') {
                        setAttribute('disabled', true, findIn('.js-product-number-spinner__up', closest('form', inputElement)));
                    }
                }

                if (inputElement.getAttribute('max') === '0') {
                    inputElement.value = 0;
                    addClass('is-disabled', closest('form', inputElement));
                    removeAttribute('hidden', findIn('.js-product-number-spinner-hint', closest('form', inputElement)));
                }
            }, closest('form', inputElement));
        }
    });
}
